import { combineReducers } from 'redux';
import bidAndWin from './bidAndWinReducer';
import bidAndWinWinners from './bidAndWinWinnersReducer';
export default combineReducers({
    bidAndWin,
    bidAndWinWinners
});
